// extracted by mini-css-extract-plugin
export default {"requiredCheckbox":"BudgetFieldScreen_requiredCheckbox__4+vzR","dragIconContainer":"BudgetFieldScreen_dragIconContainer__5WoTG","dragIcon":"BudgetFieldScreen_dragIcon__aNxLE"};